import { styled } from '@mui/material'
import { mobile } from '../../../../../utils/breakpoints'
export const StyledIcon = styled('svg')`
  font-size: 40px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.secondary.light};
  margin-right: 15px;
  transition:
    color 0.3s,
    transform 0.3s; // Smooth transition for color and scale

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }

  ${({ theme }) => mobile(theme, { 'font-size': '30px' })}
`
